export const environment = {
  production: true,
  apiUrl: 'https://dev-api.salis.ae/api',
};
